import React, { Fragment } from "react";
import ReactAudioPlayer from "react-audio-player";
import { friendlyDateTime } from "../../../utils";
import { DefaultButton, Icon } from "../../widgets";
// https://www.figma.com/proto/RiCYTBxcJJcuAC0CVQeTFU/CuGate?node-id=1454%3A4016&scaling=min-zoom&page-id=306%3A3928&starting-point-node-id=306%3A3929
// https://www.figma.com/file/RiCYTBxcJJcuAC0CVQeTFU/CuGate?node-id=1454%3A4016&t=FlQhdf6l8FqCvT5p-0
export const TrackView: React.FC<any> = (props) => {
    const {
        trackSearch = [],
        handleMore,
        moreLoading,
        handleTrackDetail,
        tempoList = [],
        genreList = [],
        moodList = [],
        formData,
    } = props.data;

    return (
        <Fragment>
            {trackSearch.list?.map((item: any, index: number) => formData.sort_by === 'played_ranking' || formData.sort_by === 'played_count' ? (
                <div
                    className="col-12 row-item mb-3"
                    key={"item_" + index}
                >
                    <div className="item-header d-flex justify-content-between">
                        <div className="d-flex flex-column">
                            <span className="title">
                                {item.media}
                                <span></span>
                            </span>
                            <span className="description">
                                Published: {item.lastUpdated} by: {item.artist}
                            </span>
                        </div>
                        <div className="">
                            <ReactAudioPlayer
                                src={`https://prelistening.cugate.com/?i=${item.file_info.file_id}`}
                                // autoPlay
                                controls
                                style={{ height: "35px", marginRight: "15px" }}
                            />
                            <DefaultButton
                                className="small-button"
                                color="var(--button-background-color)"
                                textColor="var(--button-text-color)"
                                borderColor="var(--button-border-color)"
                                onClick={() =>
                                    handleTrackDetail(item)
                                }
                            >
                                View
                            </DefaultButton>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex item-album w-100">
                            <img
                                src={`https://img.cugate.com/?i=${item.albumId}&o=album`}
                                alt=""
                            />
                            <div className="ms-2 item-album-title w-100">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.resume
                                    }}
                                ></div>
                                <div className="d-flex description mt-4">
                                    <div
                                        className={item.rank + "," + item.lastRank}
                                    >
                                        <span className="me-1">Rank:</span>
                                        {item.lastRank == null ||
                                            item.rank < item.lastRank ? (
                                            <span className="color-green">
                                                {item.rank}
                                                <Icon name="arrow-up" />
                                            </span>
                                        ) : (
                                            <span className="color-red">
                                                {item.rank}
                                                <Icon name="arrow-down" />
                                            </span>
                                        )}
                                    </div>
                                    <div className="ms-4">
                                        <span className="me-1">Type:</span>
                                        {item.file_info.f_track_type_title}
                                    </div>
                                    {item.weibo && (
                                        <div className="ms-4">
                                            <span className="me-1">Composer:</span>
                                            {item.weibo}
                                        </div>
                                    )}
                                    {tempoList.filter(
                                        (g: any) => item.tempo <= g.range
                                    ).length > 0 && (
                                            <div className="ms-4">
                                                <span className="me-1">Tempo:</span>
                                                {
                                                    tempoList.filter(
                                                        (g: any) => item.tempo <= g.range
                                                    )[0].text
                                                }
                                            </div>
                                        )}
                                    {genreList.filter(
                                        (g: any) => g.id === item.genre
                                    ).length > 0 && (
                                            <div className="ms-4">
                                                <span className="me-1">Genre:</span>
                                                {
                                                    genreList.filter(
                                                        (g: any) => g.id === item.genre
                                                    )[0].title
                                                }
                                            </div>
                                        )}
                                    {moodList.filter((g: any) => g.id === item.key)
                                        .length > 0 && (
                                            <div className="ms-4">
                                                <span className="me-1">Mood:</span>
                                                {
                                                    moodList.filter(
                                                        (g: any) => g.id === item.key
                                                    )[0].title
                                                }
                                            </div>
                                        )
                                    }
                                    <div className="ms-4">
                                        <span className="me-1">Time:</span>
                                        {item.file_info.f_track_time / 1000}s
                                    </div>
                                </div>
                                <div className="d-flex description">
                                    <div className="d-flex w-100">
                                        <span className="me-2 mt-1">Frequency:</span>
                                        <div
                                            style={{
                                                width: "100%",
                                                maxWidth: "400px",
                                                backgroundColor: "#dcfdff",
                                                marginTop: 4,
                                                borderRadius: 2,
                                                color: "black"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width:
                                                        (100 * item.sum_count) /
                                                        trackSearch.pagination.sum +
                                                        "%",
                                                    height: "100%",
                                                    backgroundColor: "var(--color-blue-light)"
                                                }}
                                            >
                                                <span className="fw-bold ms-2">
                                                    {item.sum_count}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ms-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div
                            className="d-flex align-items-end"
                            style={{ color: "grey" }}
                        >
                            {item.played_count > 0
                                ? item.played_count + " played"
                                : ""}
                        </div>
                    </div>
                </div>
            ) : (
                <Fragment>
                    {index?(<></>):(
                    <div className="col-12 row-item table-header mb-3" key={"item_head"}>
                        <div></div>
                    </div>
                    )}
                    <div className="col-12 row-item mb-3" key={"item_" + index}>
                        <div className="item-header d-flex justify-content-between">
                            <div className="d-flex flex-column">
                                <span className="title">
                                    {item.title}
                                    <span></span>
                                </span>
                                <span className="description">
                                    Date: {friendlyDateTime(item.update_time)}
                                </span>
                            </div>
                            <div className={item.exist_file===1?"":"d-none"}>
                                <ReactAudioPlayer
                                    src={`https://prelistening.cugate.com/?i=${item.file_info.id}`}
                                    // autoPlay
                                    controls
                                    style={{ height: "35px", marginRight: "15px" }}
                                />
                                <DefaultButton
                                    className="small-button"
                                    color="var(--button-background-color)"
                                    textColor="var(--button-text-color)"
                                    borderColor="var(--button-border-color)"
                                    onClick={() =>
                                        handleTrackDetail(item)
                                    }
                                >
                                    View
                                </DefaultButton>
                            </div>
                        </div>
                        <div className="d-flex flex-column">
                            <div className="d-flex item-album w-100 mt-3">
                                <div className="d-flex focus" onClick={() => window.open(`https://www.cumarket.net/album/${item.album_info.id}`)}>
                                    <img
                                        src={`https://img.cugate.com/?i=${item.album_info.id}&o=album`}
                                        alt=""
                                    />
                                    <div className="ms-2">
                                        <div className="fw-bold">Album</div>
                                        <div className="album-title">{item.album_info.title}</div>
                                    </div>
                                </div>
                                <div className="d-flex flex-wrap member-list">
                                    {item.members?.map((member: any, mindex: number) => (
                                        <div key={mindex} className="d-flex flex-wrap  ms-4 focus" onClick={() => window.open(`https://www.cumarket.net/artist/${member.id}i${item.album_info.id}`)}>
                                            <img
                                                className="me-2"
                                                src={`https://img.cugate.com/?i=${member.id}&o=member`}
                                                alt=""
                                            />
                                            <div className="member-info">
                                                <div className="fw-bold">{member.role}</div>
                                                <div className="flex-shrink-0 member-name">{member.name}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="item-album-title w-100">
                                <div className="d-flex description mt-2 flex-wrap">
                                    {genreList.filter(
                                        (g: any) => g.id === item.genre_id
                                    ).length > 0 && (
                                            <div className="ms-4">
                                                <span className="me-1">Genre:</span>
                                                {
                                                    genreList.filter(
                                                        (g: any) => g.id === item.genre_id
                                                    )[0]?.title
                                                }
                                            </div>
                                        )}
                                    {genreList.filter(
                                        (g: any) => g.id === item.subgenre_id
                                    ).length > 0 && (
                                            <div className="ms-4">
                                                <span className="me-1">Sub Genre:</span>
                                                {
                                                    genreList.filter(
                                                        (g: any) => g.id === item.subgenre_id
                                                    )[0]?.title
                                                }
                                            </div>
                                        )}
                                    {item.fp_rel?.moods?.length > 1 ? (<>
                                        <div className="ms-4 d-flex flex-wrap">
                                            <span className="me-1">Mood:</span>
                                            {
                                                item.fp_rel.moods?.map((m: any) => m !== '' && (
                                                    <span className="me-1">
                                                        {moodList.filter(
                                                            (g: any) => g.id === Number(m)
                                                        )[0]?.title}
                                                        {
                                                            " " + Math.round((item.fp_rel.real_moods.match(new RegExp(`,${m},`, 'g')) || []).length*100/(item.fp_rel.real_moods.split(',').length-2)) + "%"
                                                        }
                                                        ,
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    </>) : (<></>)}
                                    {tempoList.filter(
                                        (g: any) => g.id === item.tempo_id
                                    ).length > 0 && (
                                            <div className="ms-4">
                                                <span className="me-1">Tempo:</span>
                                                {
                                                    tempoList.filter(
                                                        (g: any) => g.id === item.tempo_id
                                                    )[0]?.title
                                                }
                                            </div>
                                        )}
                                    <div className="ms-4">
                                        <span className="me-1">Time:</span>
                                        {item.file_info.track_time / 1000}s
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            ))}
            {trackSearch.pagination.pages > 0 &&
                trackSearch.pagination.pages >
                trackSearch.pagination.page + 1 && (
                    <div className="row d-flex justify-content-center w-100 mt-4 mb-4">
                        <div style={{ width: "200px", textAlign: "center" }}>
                            <DefaultButton
                                color="var(--button-background-color)"
                                textColor="var(--button-text-color)"
                                borderColor="var(--button-border-color)"
                                className={"mb-3"}
                                onClick={() => handleMore()}
                            >
                                {moreLoading ? <Icon name="loading" /> : "More"}
                            </DefaultButton>
                        </div>
                    </div>
                )}
        </Fragment>
    );
};

export default TrackView;
